import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css"; // Import Tailwind styles
import App from "./App";

// Remove or comment out reportWebVitals
// import reportWebVitals from './reportWebVitals';

// Render the app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// Remove or comment out this line
// reportWebVitals();
